import { createInput } from "./createInput";

export const Year = createInput({
  sx: (theme) => ({
    width: theme.spacing(12),
    marginLeft: theme.spacing(2),
  }),
  fieldName: "year",
  updaterName: "changeYear",
  maxLength: 4,
});
